import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, TargetIcon, WindIcon } from 'lucide-react';
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function MarketSlide() {
  return <motion.div className="w-full h-full flex flex-col px-12 py-10" variants={stagger} initial="hidden" animate="visible" data-id="element-181">
      <motion.div variants={fadeUp} className="flex items-center gap-3 mb-2" data-id="element-182">
        <span className="text-base text-[#00d4ff] font-semibold tracking-widest uppercase" data-id="element-183">
          05
        </span>
        <span className="w-8 h-[1px] bg-[#00d4ff] opacity-50" data-id="element-184" />
      </motion.div>

      <motion.h2 variants={fadeUp} className="text-4xl md:text-5xl font-extrabold text-white mb-3" data-id="element-185">
        Market / Opportunity
      </motion.h2>

      <motion.p variants={fadeUp} className="text-2xl text-[#8899aa] mb-8 max-w-3xl" data-id="element-186">
        $120B+ AI inference market, with growing demand for cost-efficient
        alternatives
      </motion.p>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-187">
        <motion.div variants={fadeUp} className="glass-card p-6 flex flex-col" data-id="element-188">
          <div className="w-10 h-10 rounded-lg bg-[rgba(0,212,255,0.1)] flex items-center justify-center mb-4" data-id="element-189">
            <TrendingUpIcon className="w-5 h-5 text-[#00d4ff]" data-id="element-190" />
          </div>
          <p className="text-base text-[#00d4ff] font-semibold uppercase tracking-wider mb-3" data-id="element-191">
            TAM by 2030
          </p>
          <p className="text-[18px] text-white/80 leading-relaxed flex-1" data-id="element-192">
            AI inference total addressable market: $250B by 2030; majority of AI
            spend shifts from GPUs to FPGAs and ASICs per Goldman Sachs.
          </p>
          <p className="text-base text-[#8899aa] mt-3 opacity-60" data-id="element-193">
            Source: Chang, Allen, et al. Goldman Sachs Global Investment
            Research, 4 Jan. 2026.
          </p>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-6 flex flex-col" data-id="element-194">
          <div className="w-10 h-10 rounded-lg bg-[rgba(255,107,53,0.1)] flex items-center justify-center mb-4" data-id="element-195">
            <TargetIcon className="w-5 h-5 text-[#ff6b35]" data-id="element-196" />
          </div>
          <p className="text-lg text-[#ff6b35] font-semibold uppercase tracking-wider mb-3" data-id="element-197">
            Target Segments
          </p>
          <ul className="space-y-2.5 text-[18px] text-white/80 flex-1" data-id="element-198">
            <li className="flex items-start gap-2" data-id="element-199">
              <span className="w-1.5 h-1.5 rounded-full bg-[#ff6b35] mt-1.5 flex-shrink-0" data-id="element-200" />
              LLM-driven vertical apps
            </li>
            <li className="flex items-start gap-2" data-id="element-201">
              <span className="w-1.5 h-1.5 rounded-full bg-[#ff6b35] mt-1.5 flex-shrink-0" data-id="element-202" />
              High-frequency trading
            </li>
            <li className="flex items-start gap-2" data-id="element-203">
              <span className="w-1.5 h-1.5 rounded-full bg-[#ff6b35] mt-1.5 flex-shrink-0" data-id="element-204" />
              Space, health, and power constrained edge systems
            </li>
          </ul>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-6 flex flex-col glow-cyan" data-id="element-205">
          <div className="w-10 h-10 rounded-lg bg-[rgba(0,212,255,0.1)] flex items-center justify-center mb-4" data-id="element-206">
            <WindIcon className="w-5 h-5 text-[#00d4ff]" data-id="element-207" />
          </div>
          <p className="text-lg text-[#00d4ff] font-semibold uppercase tracking-wider mb-3" data-id="element-208">
            Tailwind
          </p>
          <p className="text-[18px] text-white/80 leading-relaxed flex-1" data-id="element-209">
            As GPU memory costs rise, FPGA provides a more optimal track
          </p>
          {/* Simple upward trend graphic */}
          <svg className="w-full h-16 mt-4" viewBox="0 0 200 50" fill="none" data-id="element-210">
            <path d="M0 45 Q50 40 80 30 T140 15 T200 5" stroke="#00d4ff" strokeWidth="2" fill="none" opacity="0.6" data-id="element-211" />
            <path d="M0 45 Q50 40 80 30 T140 15 T200 5 V50 H0 Z" fill="url(#trendGrad)" opacity="0.15" data-id="element-212" />
            <defs data-id="element-213">
              <linearGradient id="trendGrad" x1="0" y1="0" x2="0" y2="1" data-id="element-214">
                <stop offset="0%" stopColor="#00d4ff" data-id="element-215" />
                <stop offset="100%" stopColor="transparent" data-id="element-216" />
              </linearGradient>
            </defs>
          </svg>
        </motion.div>
      </div>
    </motion.div>;
}